import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-6" }
const _hoisted_2 = { class: "gfu-hd gfu-hd--h2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString($props.title), 1 /* TEXT */),
    _createVNode(_component_box, {
      class: "_flexcol _gap-6",
      thick: ""
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3 /* FORWARDED */
    })
  ]))
}